import React from "react";
import theme from "src/theme";
import styled from "styled-components";

import SocialNetworks from "../../../../../../../components/SocialNetworks";
import AboutSection from "../AboutSection";
import HelpSection from "../HelpSection";
import LegalNotice from "../LegalNotice";
import { Newsletter } from "../Newsletter";
import PaymentSection from "../PaymentSection";
import ReinsuranceSection from "../ReinsuranceSection";

const DarkBackground = styled.div`
  width: 100%;
  background: ${theme.colors.darkBlack};
  color: ${theme.colors.white};
`;

const FooterTablet = (): JSX.Element => (
  <>
    <div className="container">
      <ReinsuranceSection />
    </div>
    <DarkBackground>
      <div className="container">
        <div className="row">
          <div className="col">
            <AboutSection />
          </div>
          <div className="col">
            <PaymentSection />
          </div>
          <div className="col">
            <HelpSection />
          </div>
          <div className="col">
            <Newsletter renderSocial={<SocialNetworks />} />
          </div>
        </div>
      </div>
    </DarkBackground>
    <div className="container">
      <LegalNotice />
    </div>
  </>
);

export default FooterTablet;
